var map = {
	"./admin/UK/team.json": [
		1029,
		1029
	],
	"./brother_marcus/UK/team.json": [
		2510,
		2510
	],
	"./brother_marcus_south_ken/UK/team.json": [
		4205,
		4205
	],
	"./honest_burger/UK/team.json": [
		791,
		791
	],
	"./lina/UK/team.json": [
		3550,
		3550
	],
	"./moto/UK/team.json": [
		9341,
		9341
	],
	"./pizza_express/UK/team.json": [
		5367,
		5367
	],
	"./pret/UK/team.json": [
		2539,
		2539
	],
	"./sushi_dog/UK/team.json": [
		5317,
		5317
	],
	"./tossed/UK/team.json": [
		9686,
		9686
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7325;
module.exports = webpackAsyncContext;